import { CosDataTo } from './cosDataTo';

export class ClassOfServiceTo {
    id: string;
    orgId: string;
    global: boolean;
    data: CosDataTo[];

    constructor(object?: any) {
        this.id = object?.id;
        this.orgId = object?.orgId;
        this.global = object?.global ?? false;
        this.data = [];
        object?.data?.forEach(element => {
            this.data.push(new CosDataTo(element));
        });
    }
}
